import { Outlet, Link } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      {/* Left panel — decorative */}
      <div className="hidden lg:flex lg:w-1/2 bg-hero-gradient relative overflow-hidden">
        {/* Circles */}
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-salon-primary/30 blur-3xl" />
        <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-salon-secondary/20 blur-3xl" />
        <div className="absolute top-1/3 left-1/4 w-48 h-48 rounded-full bg-salon-accent/10 blur-2xl" />

        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <Link to="/" aria-label="Salon Vora — Home" className="inline-block">
            <img src="/brand/logo.jpg" alt="Salon Vora" width="220" height="80" className="h-14 w-auto rounded-md object-contain" />
          </Link>

          <div>
            <div className="divider-gold mb-6" />
            <p className="font-display text-white text-4xl font-bold leading-tight mb-4">
              Where beauty meets<br />
              <em className="text-salon-secondary">elegance</em>
            </p>
            <p className="text-salon-cream/70 font-body text-lg leading-relaxed">
              Book appointments, explore our services, and experience luxury beauty care from the comfort of your home.
            </p>
          </div>

          <p className="text-salon-cream/40 font-body text-sm">
            © {new Date().getFullYear()} Salon Vora. All rights reserved.
          </p>
        </div>
      </div>

      {/* Right panel — form */}
      <div className="flex-1 flex items-center justify-center bg-salon-cream px-6 py-12">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <Link to="/" aria-label="Salon Vora — Home" className="lg:hidden mb-8 inline-block">
            <img src="/brand/logo.jpg" alt="Salon Vora" width="220" height="80" className="h-14 w-auto rounded-md object-contain" />
          </Link>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
